type DlfMatcherTypes =
  | "F_FUZZY"
  | "F_REGEX"
  | "F_KEYVALUE"
  | "F_SECTION"
  | "F_COLUMN"
  | "F_DEFAULT";

const DlfMatcherTypesKeys: DlfMatcherTypes[] = [
  "F_FUZZY",
  "F_REGEX",
  "F_KEYVALUE",
  "F_SECTION",
  "F_COLUMN",
  "F_DEFAULT",
];

const isDlfMatcherTypes = (value: string): value is DlfMatcherTypes => {
  return DlfMatcherTypesKeys.indexOf(value as DlfMatcherTypes) > -1;
};

const getDlfMatcherTypes = () => {
  return [...DlfMatcherTypesKeys];
};

const getDlfMatcherTypesDisplayValue = (key: DlfMatcherTypes): string => {
  switch (key) {
    case "F_REGEX":
      return "Regex";
    case "F_KEYVALUE":
      return "Key Value";
    case "F_DEFAULT":
      return "Hardcode";
    case "F_FUZZY":
      return "Fuzzy";
    default:
      return key;
  }
};

export {
  DlfMatcherTypes,
  isDlfMatcherTypes,
  getDlfMatcherTypes,
  getDlfMatcherTypesDisplayValue,
};
